import {PUBLIC_API_V1_BASE} from '../config/publicApi';

const FILE_SIZE_LIMIT_IN_BYTES = (10 * 1048576);

export const submitFormDataAsJsonString = async (formData, apiSubDirectory) => {
    let response;
    try {
        response = await fetch(PUBLIC_API_V1_BASE + apiSubDirectory, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        printConsoleLog(response);
    } catch (error) {
        console.error(error);
        return {
            status: 0,
            text: '',
        };
    }

    if (!response) {
        return {
            status: 0,
            text: '',
        };
    }

    return {
        status: response.status,
        text: await response.text()
    };
};

export const submitFormDataAsObject = async (formData, apiSubDirectory) => {
    let response;
    try {
        response = await fetch(PUBLIC_API_V1_BASE + apiSubDirectory, {
            method: 'POST',
            body: formData
        });
        printConsoleLog(response);
    } catch (error) {
        console.error(error);
    }

    const data = await response;

    return {
        status: data.status,
        text: await data.text()
    };
};

export const createFormData = (file,
                               adminFrom,
                               userFrom,
                               adminEmail,
                               userEmail,
                               adminSubject,
                               userSubject,
                               adminHtmlTemplate,
                               userHtmlTemplate,
                               firstName,
                               lastName,
                               email,
                               phone,
                               city,
                               state,
                               country,
                               message) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('adminFrom', adminFrom);
    formData.append('userFrom', userFrom);
    formData.append('adminEmail', adminEmail);
    formData.append('userEmail', userEmail);
    formData.append('adminSubject', adminSubject);
    formData.append('userSubject', userSubject);
    formData.append('adminHtmlTemplate', adminHtmlTemplate);
    formData.append('userHtmlTemplate', userHtmlTemplate);
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('city', city);
    formData.append('state', state);
    formData.append('country', country);
    formData.append('message', message);

    return formData;
};

export const validateTextarea = (textareaInputId, errorMessageId) => {
    const textarea = document.getElementById(textareaInputId);
    const pattern = /^(?!.*(<script|<iframe)\b)[\s\S]*$/;
    const errorMessage = document.getElementById(errorMessageId);
    if (!pattern.test(textarea.value)) {
        errorMessage.style.display = "block";
        return false;
    } else {
        errorMessage.style.display = "none";
        return true;
    }
};

export const validateFileSize = (size, fileInputId, errorMessageId) => {
    const errorMessage = document.getElementById(errorMessageId);
    if (size > FILE_SIZE_LIMIT_IN_BYTES) {
        errorMessage.style.display = "block";
        document.getElementById(fileInputId).value = '';
        return false;
    }
    errorMessage.style.display = "none";
    return true;
};

export const printConsoleLog = (status, message) => {
    // console.log(`Status: ${status} , Message: ${message}`)
}

export const redirectPage = (redirectTo) => {
    window.location.href = redirectTo;
}

export const getAdminEmail = () => {
    return "{{_DEFAULT_ADMIN_EMAIL_}}";
}

export const showDialog = (id) => {
    try {
        const el = document.getElementById(id);
        if (!el || typeof el.showModal !== 'function') {
            return;
        }
        // Second `showModal()` while open throws InvalidStateError and would skip caller `finally`.
        if (el.open) {
            return;
        }
        el.showModal();
    } catch (e) {
        console.warn('showDialog: could not open', id, e);
    }
};

export const closeDialog = (id) => {
    try {
        const dialog = document.getElementById(id);
        if (dialog && typeof dialog.close === 'function' && dialog.open) {
            dialog.close();
        }
    } catch (e) {
        console.warn('closeDialog:', id, e);
    }
};

/**
 * Scroll the embedded app / iframe document to top (long forms; submit at bottom).
 * Uses scrollingElement for reliable behavior across browsers.
 */
export const scrollFormsViewToTop = () => {
    try {
        window.scrollTo({top: 0, left: 0, behavior: 'auto'});
        const se = document.scrollingElement;
        if (se) {
            se.scrollTop = 0;
            se.scrollLeft = 0;
        }
        if (document.documentElement) {
            document.documentElement.scrollTop = 0;
            document.documentElement.scrollLeft = 0;
        }
        if (document.body) {
            document.body.scrollTop = 0;
            document.body.scrollLeft = 0;
        }
    } catch (_) {
        /* ignore */
    }
};


export const splitMessageContent = (message) => {
    return message.split('\n');
}

export const addClickableLinkToContent = (content, text, link) => {
    content = content
        .replaceAll(
            text,
            `<a target="_blank" rel="noreferrer" 
                href="${link}" class="text-decoration-none" 
                style="color: rgb(166, 0, 0);">${text}
            </a>`
        );

    return content;
}

export const addClickableLinksToContent = (content, links) => {
    links.forEach(({text, link}) => {
        content = content.replaceAll(
            text,
            `<a target="_blank" rel="noreferrer" 
                href="${link}" class="text-decoration-none" 
                style="color: rgb(166, 0, 0);">${text}
            </a>`
        );
    });
    return content;
};

export const addBoldTextToContent = (content, links) => {
    links.forEach(({text, textToBold}) => {
        content = content.replaceAll(
            text,
            `<b>${text}</b>`
        );
    });
    return content;
};

export const formatContent = (content, modifications) => {
    modifications.forEach(({text, link, bold}) => {
        let replacement = text;

        if (bold) {
            replacement = `<b>${replacement}</b>`;
        }

        if (link) {
            replacement = `<a target="_blank" rel="noreferrer" 
                href="${link}" class="text-decoration-none" 
                style="color: rgb(166, 0, 0);">${replacement}
            </a>`;
        }

        content = content.replaceAll(text, replacement);
    });

    return content;
};